module.exports = __webpack_public_path__ + "static/media/hometelecom.7ba71794.png";